import en from './en-US';
import jp from './fr-jp';

export default {
  ...en,
  ...jp,
};
